import React, { Dispatch, useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Pencil, Plus, Trash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import Grid, { GridColumn, GridHeader, GridRow } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import PageTitle from "../../components/PageTitle/PageTitle";
import routePaths from "../../Navigation/routePaths";
import AddRole from "./AddRole";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";

const headers: GridHeader[] = [
  {
    title: "Role",
    class: "text-left",
  },
  {
    title: "Date",
    class: "text-left",
  },
  {
    title: "Action",
    class: "text-center freeze-column",
    headerClass: "text-center",
    isSorting: false,
    isFilter: false,
    isFreeze: true,
  },
];

const RolePage = () => {
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id }: any = useParams();
  const nextOffset = useRef<number>(0);
  const keyword = useRef<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [expenseId, setExpenseId] = useState<string>("");
  const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
  const [rows, setRows] = useState<GridRow[]>([]);
  const rowCompute = useRef<GridRow[]>([]);
  const [showAddRole, setShowAddRole] = useState<boolean>(false);
  const [editRoleData, setEditRoleData] = useState<any>(null);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);

  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "USERS"));
    }
  }, [token])

  useEffect(() => {
    token && token.user && token.user?.role && token.user?.role.role !== "ADMIN" && navigate(routePaths.HOME.path);
  }, [])


  const actionList = (data: any) => {
    return (
      <div className="action-btns">
        <button
          className="cursor-pointer  btn-edit btn"
          onClick={() => { setEditRoleData(data); setShowAddRole(true); }}
        >
          {" "}
          <Pencil />{" "}
        </button>
        {/* <button
          onClick={() => onConfirmDelete(data)}
          className="cursor-pointer btn btn-delete"
        >
          {" "}
          <Trash />{" "}
        </button> */}
      </div>
    );
  };

  const getRoleList = (
    offset: number,
    keyword?: string,
    startDate?: Date,
    endDate?: Date,
    order_by?: string,
    sort_by?: string
  ) => {
    nextOffset.current = offset;
    if (nextOffset.current < 0 || isLoading) {
      return;
    }
    setIsLoading(true);
    WebService.getAPI({
      action: `get-role-list`,
      body: null,
    })
      .then((res: any) => {
        setIsLoading(false);
        let rows: GridRow[] = [];
        for (var i in res.roles) {
          let columns: GridColumn[] = [];
          columns.push({
            value: res.roles[i]?.role ? res.roles[i].role : "N/A",
          });
          columns.push({
            value:
              res.roles[i].created_at &&
              HelperService.getFormatedDate(res.roles[i].created_at),
          });
          columns.push({
            value: actionList(res.roles[i]),
            type: "COMPONENT",
          });
          rowCompute.current.push({ data: columns });
          rows.push({ data: columns });
        }
        rowCompute.current = rows;
        setRows(rowCompute.current);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
    getRoleList(
      offset,
      null as any,
      null as any,
      null as any,
      isAscending ? "asc" : "desc",
      key
    ); 
  };

  const onDelete = () => {
    setDeleteModal(false);
    setIsLoading(true);
    WebService.deleteAPI({
      action: `expense/delete/${expenseId}`,
      body: null,
    })
      .then((res: any) => {
        setIsLoading(false);
        toast.success(res.message);
        setExpenseId("");
        getRoleList(1);
      })
      .catch((e) => {
        setIsLoading(false);
        setExpenseId("");
      });
  };

  return (
    <>
      <DeleteModal isShow={showDeleteModal} close={() => { setDeleteModal(false); }} onDelete={() => { onDelete(); }} />
      <AddRole isShow={showAddRole} isClose={(e: boolean) => { setShowAddRole(false); setEditRoleData(null); e && getRoleList(1) }} data={editRoleData} />
      {permissions && permissions.can_read && <div className="app-page page-dashboard">
        <div className="d-flex justify-content-between align-items-center ">
          <PageTitle title="Roles" backArrow={true} />
          <Button className="btn btn-brand-1 mb-3" onClick={() => setShowAddRole(true)}> {" "}<Plus size={20} className="ms-1" /> Add Role</Button>
        </div>
        <div className="table-card">
          <Grid
            rows={rows}
            // showSearch={true}
            headers={headers}
            // showDateFilter={true}
            onPageChange={getRoleList}
            errorMessage={"No Roles Found"}
            ShowLoader={isLoading}
            onSort={onSortList}
          />
        </div>
      </div>}
    </>
  );
};

export default RolePage;
